<template>
  <v-row class="mt-6 pt-0 mt-0">
    <v-col class="pt-0 mt-0" md="3">
      <v-card>
        <v-row>
          <v-col md="12" class="pa-0 pl-3">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle>On Time</v-list-item-subtitle>
                <v-list-item-title class="display-1 mb-1 success--text">
                  {{ card_data.on_time_count }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col class="pt-0" md="3">
      <v-card>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle>In Tolerance</v-list-item-subtitle>
            <v-list-item-title class="display-1 mb-1 warning--text">
              {{ card_data.time_in_tolerance_count }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
    <v-col class="pt-0" md="3">
      <v-card>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle>Late</v-list-item-subtitle>
            <v-list-item-title class="display-1 mb-1 error--text">
              {{ card_data.late_count }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
    <v-col class="pt-0" md="3">
      <v-card>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle>Total Absent</v-list-item-subtitle>
            <v-list-item-title class="display-1 mb-1 primary--text">
              {{ card_data.absent_count }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
// import axios from "axios";
export default {
  name: "DashboardCards",
  props: ["card_data"],
  data() {
    return {};
  },
};
</script>
